// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.syntax-highlighter {
  position: relative;
  font-size: 14px;
  line-height: 20px;
}
.syntax-highlighter__code {
  width: 100%;
  height: 100%;
  margin: 0;
  scrollbar-width: thin;
}
.syntax-highlighter__buttons {
  position: absolute;
  top: 0;
  right: 0;
}
.syntax-highlighter__button:not(.copy-to-clipboard--active) {
  background-color: color-mix(in srgb, var(--color-neutral-background-base) 80%, transparent);
}
.syntax-highlighter__button:not(.copy-to-clipboard--active):hover {
  background-color: var(--color-neutral-background-base);
}
.syntax-highlighter__switch {
  margin-right: 2px;
}
.syntax-highlighter pre,
.syntax-highlighter code {
  font-family: 'JetBrains Mono';
}
.syntax-highlighter--wrapLines .syntax-highlighter__code {
  word-break: break-all;
  word-wrap: break-word;
}
.syntax-highlighter--wrapLines code {
  white-space: pre-wrap;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/common/ui/syntax-highlighter/SyntaxHighlighter.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AASF;AAPE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,qBAAA;AASJ;AANE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AAQJ;AAJI;EACE,2FAAA;AAMN;AAJM;EACE,sDAAA;AAMR;AADE;EACE,iBAAA;AAGJ;AAhCA;;EAkCI,6BAAA;AAEJ;AACE;EAEI,qBAAA;EACA,qBAAA;AAAN;AAHE;EAOI,qBAAA;AADN","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.syntax-highlighter {\n  position: relative;\n  font-size: @fontSize-sm;\n  line-height: 20px;\n\n  &__code {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    scrollbar-width: thin;\n  }\n\n  &__buttons {\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n\n  &__button {\n    &:not(.copy-to-clipboard--active) {\n      background-color: color-mix(in srgb, var(--color-neutral-background-base) 80%, transparent);\n\n      &:hover {\n        background-color: var(--color-neutral-background-base);\n      }\n    }\n  }\n\n  &__switch {\n    margin-right: 2px;\n  }\n\n  pre,\n  code {\n    font-family: @JetBrainsMono;\n  }\n\n  &--wrapLines {\n    .syntax-highlighter__code {\n      word-break: break-all;\n      word-wrap: break-word;\n    }\n\n    code {\n      white-space: pre-wrap;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
